/* eslint-disable react/jsx-key */
/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import UCSColors from "@ucs/Utils/UCSColors";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    overrideTitle = "overrideTitle",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.overrideTitle]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const paddingStyles: InjectableCss = {
    css: css`
        display: inline-block;
        font-size: 48px;
        ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css`
                    padding: 0 10px;
                `,
                css`
                    padding: 0 12px;
                `,
                css``,
                css``,
                css``,
            ]);
        }}
    `,
};

const myAccountH1Styles: TypographyProps = {
    color: "black",
    variant: "h1",
    as: "h1",
    css: css`
        display: inline-block;
        /* font-size: 48px; */
        margin-bottom: 16px;
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme,
                [
                    css``,
                    css`
                        margin-top: 0;
                        width: 100%;
                    `,
                    css``,
                    css``,
                    css``,
                ],
                "max",
            );
        }}
    `,
};

const myAccountH3Styles: TypographyProps = {
    color: UCSColors.gray05,
    variant: "h3",
    as: "h3",
    css: css`
        display: inline-block;
        margin-top: 16px;
        margin-bottom: 16px;
        margin-right: 16px;
        ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css`
                    margin-bottom: 0;
                `,
                css`
                    margin-bottom: 0;
                `,
                css`
                    font-size: 48px !important;
                `,
                css`
                    font-size: 48px !important;
                `,
                css`
                    font-size: 48px !important;
                `,
            ]);
        }}
    `,
};

const getMyAccountStyles = (isH1: boolean) => {
    return isH1 ? myAccountH1Styles : myAccountH3Styles;
};

const PageTitle: React.FunctionComponent<Props & OwnProps> = ({ pageTitle, fields }: Props) => {
    const titleSplit = fields.overrideTitle ? fields.overrideTitle.split("/") : [];

    if (titleSplit.length > 1) {
        return (
            <>
                {titleSplit.map((titleChunk: string, i: number) => (
                    <Typography data-test-selector="PageTitle" {...getMyAccountStyles(i === titleSplit.length - 1)}>
                        {i === titleSplit.length - 1 ? titleChunk : `${titleChunk} / `}
                    </Typography>
                ))}
            </>
        );
    }
    return (
        <Typography variant="h1" as="h1" data-test-selector="PageTitle" {...paddingStyles}>
            {fields.overrideTitle || pageTitle}
        </Typography>
    );
};

const definition: WidgetDefinition = {
    group: "Basic",
    icon: "heading",
    fieldDefinitions: [
        {
            name: fields.overrideTitle,
            displayName: "Override Title",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
        },
    ],
};
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PageTitle),
    definition,
};

export default widgetModule;
